// extracted by css-extract-rspack-plugin
export default {"button":"button-f4nUOV","panel":"panel-Bck0zM","icon":"icon-N_ixzx"};